'use strict';

/*
TYpes to account for:
  custom
  apply-for-credit
  contact-dealer

  // Ones that need you to select a dealer first:
  dealer-site
  live-chat
  GXP
*/
// maps to the data-destination value that is output in DOM
define('features/ctas/cta.types',[], function () {
  return {
    dealerSite: 'dealer-site',
    compare: 'compare-vehicles',
    raq: 'request-a-quote',
    inventory: 'inventory',
    dealBuilder: 'deal-builder',
    offers: 'offers',
    chat: 'live-chat', // not yet in use
    gxp: 'gxp' // not yet in use
  };
});

